import type { FC } from 'react';
import { useCallback, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Url } from '@wix/da-url';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import StudioTableHeader from '../../../StudioTableHeader';
import { useSelector } from 'react-redux';
import TextButton from '@wix/da-ds/pkg/Buttons/TextButton';
import {
  getActiveSection,
  getPlaygroundSubsection,
  getStudioParams,
} from '../../../../selectors/studio';

import s from './SearchBlankSlate.scss';

const SEARCH_IMG_URL = Url.staticCDNLink(
  'eclipse/studio/il6-1-8_no_results.png'
);

const SearchBlankSlate: FC<{}> = () => {
  const { t } = useTranslation();
  const isMobile = useContext(MobileContext);
  const playgroundSection = useSelector(getPlaygroundSubsection);
  const activeSection = useSelector(getActiveSection);
  const studioParams = useSelector(getStudioParams);

  const onClearClick = useCallback(
    () =>
      window.location.assign(
        Url.studio({
          section: activeSection.toLowerCase() as any,
          playground: playgroundSection as any,
          folderId: studioParams?.subfolderId,
        })
      ),
    [activeSection, playgroundSection, studioParams?.subfolderId]
  );

  return (
    <div className={s['root']}>
      {!isMobile && <StudioTableHeader selectedCount={0} />}
      <div className={s['content']}>
        <img className={s['illustration']} alt="" src={SEARCH_IMG_URL} />
        <p className={s['message']}>{t('studio.blankSlate.search')}</p>
        <TextButton
          variant="approval-green"
          size="medium"
          onClick={onClearClick}
        >
          {t('studio.blankSlate.search.clearLink')}
        </TextButton>
      </div>
    </div>
  );
};
SearchBlankSlate.displayName = 'SearchBlankSlate';

export default SearchBlankSlate;
